module.exports = __webpack_public_path__ + "static/zuri-vertical-flight-society-logo-04777b3bd7e02a8606d8f0f2d56d970e.jpg";